module.exports = __webpack_public_path__ + "img/GH-kyujin-koukoku003.cd0827c5.webp";